import React from 'react';
import { func } from 'prop-types';
import Presenter from './Presenter';
import MobilePresenter from './MobilePresenter';
import Container from './Container';
import {Default,Mobile} from '../../Sizes';

const MainPageLayout = ({renderSidebar,renderHeader,renderMain,renderFooter,...props})=>{
	return (
		<Container 
			render={({sidebarProps})=> {
				return (
					<React.Fragment>
						<Default>
							<Presenter 
								sidebarProps={sidebarProps}
								renderSidebar={renderSidebar}
								renderHeader={renderHeader}
								renderMain={renderMain}
								renderFooter={renderFooter}
								{...props}
							/>
						</Default>
						<Mobile>
							<MobilePresenter 
								sidebarProps={sidebarProps}
								renderSidebar={renderSidebar}
								renderHeader={renderHeader}
								renderMain={renderMain}
								renderFooter={renderFooter}
								{...props}
							/>
						</Mobile>
					</React.Fragment>
				);
			}
				
			
			}
		/>
	);	
};
	
MainPageLayout.propTypes = {
	renderSidebar : func,
	renderHeader : func,
	renderMain : func
};
	
export default MainPageLayout;